import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Col, Transfer, Form, Input } from 'antd';
import styles from './styles.less';

const FormItem = Form.Item;

const searchFunction = (inputValue, option) => {
  return option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
};


const handleSelect = (props, items, setSelected) => {
  setSelected(items);
  props.form.setFieldsValue({
    [props.selectedFieldName]: items,
  });
};

function TwoColumnsSelect(props) {
  const { intl } = props;

  const [selected, setSelected] = useState(props.selectedValues);

  return (
    <Col span={24}>
      <FormItem>
        {props.form.getFieldDecorator(props.optionsFieldName)(<Input style={{ display: 'none' }} />)}
      </FormItem>
      <h4 className={styles.transferLeftColumnHeader}>
        <FormattedMessage id={props.optionsFieldLabel} />
      </h4>
      <h4 className={styles.transferRightColumnHeader}>
        <FormattedMessage id={props.selectedFieldLabel} />
      </h4>
      {props.form.getFieldDecorator(props.selectedFieldName)(
        <Transfer
          disabled={props.disabled}
          listStyle={{ width: '43%', height: 600 }}
          dataSource={props.disabled ? [] : props.optionValues}
          showSearch
          locale={{
            searchPlaceholder: intl.formatMessage({ id: props.searchPlaceholder }),
            notFoundContent: intl.formatMessage({ id: props.emptySearchResult }),
          }}
          filterOption={searchFunction}
          targetKeys={props.disabled ? [] : selected}
          onChange={items => handleSelect(props, items, setSelected)}
          render={item => item && item.title}
        />,
      )}
    </Col>

  );
}

const itemShape = PropTypes.shape({
  key: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string.isRequired,
});

TwoColumnsSelect.defaultProps = {
  optionsFieldLabel: 'Component.TwoColumnsSelect.AvailableLabel',
  selectedFieldLabel: 'Component.TwoColumnsSelect.SelectedLabel',
  searchPlaceholder: 'Component.TwoColumnsSelect.SearchPlaceholder',
  emptySearchResult: 'Component.TwoColumnsSelect.EmptySearchResult',
  disabled: false,
};

TwoColumnsSelect.propTypes = {
  optionsFieldName: PropTypes.string.isRequired,
  optionValues: PropTypes.arrayOf(itemShape).isRequired,
  selectedFieldName: PropTypes.string.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.func,
  ])),
  form: PropTypes.object.isRequired,
  optionsFieldLabel: PropTypes.string,
  selectedFieldLabel: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  emptySearchResult: PropTypes.string,
  disabled: PropTypes.bool,
};

export default injectIntl(TwoColumnsSelect);



// WEBPACK FOOTER //
// ./src/components/common/TwoColumnsSelect/index.js